import { Link } from 'react-router-dom';
import useTheme from '@shared/hooks/useTheme';
import styles from './LoggedOut.module.scss';

export default function LoggedOut() {
  useTheme('light');

  return (
    <div className={styles.container}>
      <h1>Du är utloggad</h1>
      <p>
        Du har loggats ut från utökad annonsering. Logga in igen för att
        fortsätta.
      </p>
      <Link className={styles.login} to="/configuration/extended-information">
        Logga in
      </Link>
    </div>
  );
}
